module.exports = __webpack_public_path__ + "static/media/skill2_pos_es.aaae80c2.txt";